module.exports = __webpack_public_path__ + "img/chanpinlunbobeijing.a7ff5439.jpg";